<template>
  <table class="category-selector">
    <thead>
      <tr>
        <th></th>
        <th>Mid</th>
        <th>Small</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="categoryGroup in categoryGroups">
        <td v-for="category in categoryGroup">
          <label v-if="category.displayText" v-bind:class="{ disabled: disabled }">
            <input
              type="checkbox"
              v-bind:disabled="disabled"
              v-bind:checked="isCategoryInRange(category.camelCase)"
              v-bind:indeterminate.prop="isCategoryInRange(category.camelCase) === 'partially'"
              v-on:change="selectOrDeselectGeneralHandsFromCategory(category.camelCase)"
            >
            {{ category.displayText }}
          </label>
          <input
            v-else
            type="checkbox"
            v-bind:disabled="disabled"
            v-bind:checked="isCategoryInRange(category.camelCase)"
            v-bind:indeterminate.prop="isCategoryInRange(category.camelCase) === 'partially'"
            v-on:change="selectOrDeselectGeneralHandsFromCategory(category.camelCase)"
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import constants from '@/services/constants';
import utilities from '@/services/utilities/utilities';

export default {
  name: 'category-selector',
  props: ['generalHands', 'disabled', 'shortDeck'],
  data: function () {
    return {
      categoryGroups: [
        [{
          displayText: 'Pocket pairs',
          camelCase: 'pocketPairs',
        }, {
          camelCase: 'mediumPocketPairs',
        }, {
          camelCase: 'smallPocketPairs',
        }], [{
          displayText: 'Suited connectors',
          camelCase: 'suitedConnectors',
        }, {
          camelCase: 'mediumSuitedConnectors',
        }, {
          camelCase: 'smallSuitedConnectors',
        }], [{
          displayText: 'Suited one gappers',
          camelCase: 'suitedOneGappers',
        }, {
          camelCase: 'mediumSuitedOneGappers',
        }, {
          camelCase: 'smallSuitedOneGappers',
        }], [{
          displayText: 'Suited aces',
          camelCase: 'suitedAces',
        }, {
          camelCase: 'mediumSuitedAces',
        }, {
          camelCase: 'smallSuitedAces',
        }], [{
          displayText: 'Suited kings',
          camelCase: 'suitedKings',
        }, {
          camelCase: 'mediumSuitedKings',
        }, {
          camelCase: 'smallSuitedKings',
        }],
      ],
    };
  },
  computed: {
    categories: function () {
      if (this.shortDeck) {
        return constants.shortDeckCategories;
      }

      return constants.categories;
    },
  },
  methods: {
    isCategoryInRange: function (categoryName) {
      return utilities.hands.areGeneralHandsInRange(this.categories[categoryName], this.generalHands);
    },
    selectOrDeselectGeneralHandsFromCategory: function (categoryName) {
      let generalHandStringsForCategory = this.categories[categoryName];

      if (this.isCategoryInRange(categoryName)) {
        this.$emit('deselectGeneralHands', generalHandStringsForCategory);
      } else {
        this.$emit('selectGeneralHands', generalHandStringsForCategory);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "node_modules/bootstrap-sass/assets/stylesheets/bootstrap/variables";
  @import "src/assets/mixins";

  @media (max-width: 672px) {
    table {
      margin-top: 20px;
      width: 100%;
      margin-left: 0 !important;

      td:nth-child(2) {
        width: 100px;
      }
    }
  }

  th {
    font-weight: normal;
    font-size: 10px;
  }

  tr {
    border-bottom: 1px solid lighten($gray-base, 75%);
  }

  th, td {
    text-align: center;
    vertical-align: middle;
  }

  td:first-child {
    text-align: left;
  }

  th:not(:first-child) {
    width: 30px;
  }

  input[type="checkbox"], label {
    cursor: pointer;
  }

  input[type="checkbox"][disabled], label.disabled {
    cursor: not-allowed;
  }

  label {
    font-weight: normal;

    @include noselect();

    input[type="checkbox"] {
      margin-right: 5px;
    }
  }


  @media (max-width: 436px) {
    td {
      line-height: 4.5;
    }

    label {
      margin-bottom: 0;
    }

    input[type="checkbox"] {
      vertical-align: text-bottom;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/category-selector.vue